import { useGtmPageView } from '../hooks/useGtmPageView'

/** Reports React Router navigations to Google Tag Manager. */
export default function GtmPageView() {
  useGtmPageView()
  return null
}
